module.exports = __webpack_public_path__ + "static/media/web.4a94ee0b.pdf";